import React from "react";

export const ContratoCrearContext = React.createContext();